'use client';
import React from 'react';
import { Container } from 'react-bootstrap';
import './about.css';
import { aboutDesc1, aboutDesc12, aboutDesc2 } from './text';
import { AboutMobileComponent } from './aboutMobile';
import Image from 'next/image';

const AboutUsComponent = () => {
  return (
    <section id="about-us" className="aboutScetion">
      <div className="mobileContainer">
        <AboutMobileComponent />
      </div>
      <div className="desktopContainer">
        <Container
          style={{ width: '80%', height: '1000px' }}
          data-aos="zoom-out"
        >
          <div className="about-card-blue"></div>
          <div className="about-card-yellow">
            <div className="about-text-container">
              <h1 className="about-heading">ABOUT US</h1>
              <p className="about-content">{aboutDesc1 + aboutDesc12}</p>
              <p className="about-content">{aboutDesc2}</p>
              <p
                className="about-achievement"
                style={{ fontSize: '20px !important' }}
              >
                <strong>NOTABLE HIGHLIGHTS</strong>
              </p>
              <p className="about-achievement">
                <strong>•</strong> THE MOST FOLLOWED FOOTBALL FAN CLUB IN INDIA
              </p>
              <p className="about-achievement">
                <strong>•</strong> 2x WINNERS OF BEST FAN CLUB IN INDIA AWARD BY
                INDIAN SPORTS HONOURS
              </p>
              <p className="about-achievement">
                <strong>•</strong> PRESENCE ACROSS THE GLOBE WITH INTERNATIONAL
                WINGS INVOLVED IN MULTIPLE FOOTBALL AND SOCIAL ACTIVITIES
              </p>
              <Image
                width={720}
                height={720}
                className="about-logo"
                src="/assets/logo.png"
                alt="logo"
              />
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
};

export default AboutUsComponent;
